import { render } from "./EditarPedido.vue?vue&type=template&id=5aad8378&scoped=true"
import script from "./EditarPedido.vue?vue&type=script&lang=js"
export * from "./EditarPedido.vue?vue&type=script&lang=js"

import "./EditarPedido.vue?vue&type=style&index=0&id=5aad8378&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aad8378"]])

export default __exports__